import { Filters, Personalisation } from 'ctp-personalisation-search';
import { namespace as createVuexClass } from 'vuex-class';

export const namespace = 'personalisation';
export const store = createVuexClass(namespace);

export const ASSOCIATE_DEVICES_TO_TOLLDOMAINS = 'associateDevicesToTollDomains';
export const FETCH_DEVICE_COUNT = 'fetchDeviceCount';
export const UPDATE_PERSONALISATIONS_LIST_STATE = 'updatePersonalisationsListState';
export const UPDATE_NAVIGATION = 'updateNavigation';
export const PERSO_NAVIGATION = 'persoNavigation';
export const FETCH_FILTER_PERSONALISATIONS = 'fetchFilterPersonalisations';
export const FETCH_PERSONALISATION_DETAILS = 'fetchPersonalisationDetails';
export const FETCH_INSTANCENAMES_BY_DEVICE_ID = 'fetchInstancesNamesByDeviceID';
export const GET_INSTANCENAMES_BY_DEVICE_ID = 'getInstanceNamesByDeviceID ';
export const SET_ERROR = 'setError';
export const REINIT = 'reinit';

interface DeviceInstance {
  id: string;
  instances: string[];
}

export interface INavigation {
  start: number;
  size: number;
  direction: 'backward' | 'forward';
  isLastPersoPage: boolean;
  filters?: Filters;
}

export interface Actions {
  label: string;
  enabled: boolean;
}

export interface IPersonalisationState {
  [view: string]: any;
}
export interface IPersonalisationListState {
  [state: string]: IPersonalisationState;
}
export interface IPersonalisationStatePayload {
  stateKey: string;
  view: string;
  stateValue: any;
}

export interface IPersonalisationDetails {
  [id: string]: any;
}
export interface PersonalisationState {
  deviceCount: number;
  instanceNames: DeviceInstance[];
  navigation: INavigation;
  errorMessage: string;
  personalisationState: IPersonalisationListState;
  personalisations: Personalisation[];
  personalisationDetails: IPersonalisationDetails;
  totalSize: number;
}
